import type { FacetValue } from "../facet-value";

export function sortByOrder(array: string[], sortOrder: string[]): string[] {
  if (array && array.length > 0 && sortOrder && sortOrder.length > 0) {
    const orderMap = new Map(sortOrder.map((item, index) => [item, index]));
    return array.slice().sort((a, b) => {
      const indexA = orderMap.get(a) ?? Infinity;
      const indexB = orderMap.get(b) ?? Infinity;
      return indexA - indexB;
    });
  }
  return array;
}

export function sortFacetValuesByOrder(array: FacetValue[], sortOrder: FacetValue[]): FacetValue[] {
  if (array && array.length > 0 && sortOrder && sortOrder.length > 0) {
    const orderMap = new Map(sortOrder.map((item, index) => [item.title, index]));
    return array.slice().sort((a, b) => {
      const indexA = orderMap.get(a.title) ?? Infinity;
      const indexB = orderMap.get(b.title) ?? Infinity;
      return indexA - indexB;
    });
  }
  return array;
}
